import Cookies from 'js-cookie';

import {
  BY_HELP_EMAIL,
  DECRYPT_EMAIL_COOKIE_ENDPOINT,
  DEV_BY_HELP_EMAIL,
  POST,
  PROD_MODE,
} from '@app/constants';
import { createServerRequest } from '@app/services';
import type { NServices } from '@app/types/Services';
import { defineDeployingMode } from '@app/utils';

export const decryptEmailCookie: NServices.DecryptEmailCookie = async ({
  emailCookie: __emailCookie,
}) => {
  const emailCookieName =
    defineDeployingMode(window.location.host) === PROD_MODE
      ? BY_HELP_EMAIL
      : DEV_BY_HELP_EMAIL;
  const emailCookie = Cookies.get(emailCookieName) || __emailCookie;

  return createServerRequest({
    method: POST,
    url: DECRYPT_EMAIL_COOKIE_ENDPOINT,
    data: {
      Content: emailCookie,
    },
  });
};
